import React, { useContext } from 'react';
import { StepWizardChildProps } from 'react-step-wizard';
import { HexpertState } from '../../contexts/HexPertProvider';
import { HexpertContext } from '../../contexts/HexPertProvider';
import { NavigationButton } from '../Buttons/NavigationButton/NavigationButton';
import './Container.scss';

type DangerHTML = {
  __html: string;
};

type ContainerProps = {
  title?: string;
  description?: string | DangerHTML;
  formHeader?: JSX.Element[] | JSX.Element; //@TODO should be content type
  tempChildren?: JSX.Element[] | JSX.Element; //@TODO should be content type
  setStartSteps?: (startPosition: HexpertState['startSteps']) => void;
  children?: JSX.Element | JSX.Element[];
  showBackButton?: boolean;
  showNextButton?: boolean;
  submitLabel?: string;
  submit?: () => void | null;
  loading?: boolean;
} & Partial<StepWizardChildProps>;

export const Container = ({
  title,
  description,
  children,
  formHeader,
  setStartSteps,
  currentStep,
  totalSteps,
  nextStep,
  previousStep,
  showBackButton = true,
  showNextButton = true,
  submitLabel,
  loading,
  submit,
}: ContainerProps) => {
  const { state } = useContext(HexpertContext);

  return (
    <div className='c-hex-form-container'>
      <div className='c-hex-container-info'>
        <p className='c-hex-container-title'>{title}</p>
        {description === typeof String ? (
          <p className='c-hex-container-description'>{description}</p>
        ) : (
          <p
            className='c-hex-container-description'
            // @ts-ignore
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        )}
      </div>
      {formHeader && <div className='c-hex-container-header'>{formHeader}</div>}
      <div className='c-hex-form-container-children'>
        {children}

        {showBackButton || showNextButton ? (
          <div className='c-hex-container-navigation-container'>
            {showBackButton && (
              <NavigationButton
                label={state.pageProps.HexpertBackLabel}
                action={() => {
                  currentStep === 1 ? setStartSteps(null) : previousStep();
                }}
                showLeftArrow
              />
            )}
            {!loading && showNextButton && (
              <NavigationButton
                label={submitLabel ? submitLabel : state.pageProps.HexpertContinueLabel}
                action={() => {
                  submit ? submit() : nextStep();
                }}
              />
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};
